import { MoneyApi } from "go-core/api/types";
import { CustomFieldEntityApi } from "go-segment/services/types";
import { FileAttachmentApi } from "../types";

export enum PartnerActionTypes {
	SET = "@@partner/SET",
	CLEAR = "@@partner/CLEAR",
}

export interface BasicPartnerApi {
	id: number;
	name: string;
	status: "DISABLED" | "ENABLED" | "DELETED";
	company_name: string;
	company_tax_id_no: string;
	company_street: string;
	company_city: string;
	company_build_nr: string;
	company_flat_nr: string;
	company_zip_code: string;
	company_phone_number: string;
	company_email: string;
	contact_person: string;
	created_at: string;
	users: PartnerUserApi[];
	codes: string[];
	provisions: PartnerProvisionApi[];
	default_provisions: PartnerProvisionApi[];
	slug: string;
	keeper: string;
	tags: string[];
	custom_fields: CustomFieldEntityApi[];
	can_create_loans: boolean;
	balance: MoneyApi;
	any_sub_partner: boolean;
	parent_id: number;
	partner_id: number;
	type: string;
	current_user_permissions: UserPermissions[];
}

export interface PartnerFormProps {
	company_phone_number: string;
	contact_person: string;
	company_email: string;
	codes: string[];
	custom_fields: CustomFieldEntityApi[];
}

export interface PartnerApi extends BasicPartnerApi {
	parent: BasicPartnerApi;
}

export interface PartnerUserApi {
	user_id: number;
	user_email: string;
	name?: string;
	permissions: UserPermissions[];
}

export interface PartnerUserListApi {
	id: number;
	email: string;
	name: string;
	permissions: UserPermissions[];
}

export interface PartnerProvisionApi {
	id: number;
	provision: number;
	start_billing_period: number;
	billing_period: number;
	type: string;
	reference_id: string;
	source: string;
	billing_period_type: "MONTHLY" | "YEARLY";
}

export interface PartnerSummaryApi {
	id: string;
	partner: PartnerApi;
	date: string;
	number: string;
	items: PartnerSummaryItemApi[];
	provision_value: MoneyApi;
	status: string;
	email_sent: boolean;
	payment_status: string;
}

export interface PartnerSummaryItemApi {
	sub_partner: PartnerApi;
	provision_value: MoneyApi;
	details: PartnerSummaryItemDetailApi[];
	organization: PartnerSummaryOrganizationApi;
}

export interface PartnerSummaryItemDetailApi {
	name: string;
	price_paid: MoneyApi;
	provision_value: MoneyApi;
	billed_period: number;
	provision: PartnerProvisionApi;
	is_added_manually: boolean;
	partner_transaction_id: number;
	description: string;
	client_id: string;
	client_name: string;
	client_company_name: string;
	client_tax_id_no: string;
	subscription_id: string;
	proforma_id: string;
}

export interface PartnerSummaryOrganizationApi {
	name: string;
}

export interface PartnerDashboardApi {
	count_of_loans_to_close: number;
	count_of_closed_loans: number;
	balance: MoneyApi;
}

export enum UserPermissions {
	MONEY_FLOW = "MONEY_FLOW",
	USERS = "USERS",
	BASIC = "BASIC",
}

export interface PartnerSearchSelectApi {
	id: string;
	label: string;
	email: string;
	name: string;
	default_provisions?: PartnerProvisionApi[];
}

export interface AddPartnerFormProps {
	partners: UpdatePartnerOrganizationItemApi[];
}

export interface UpdatePartnerOrganizationItemApi {
	partner_id: number;
	provisions: PartnerProvisionApi[];
	id: number;
}

export interface PartnerPayoutInvoiceFormProps {
	attachments: FileAttachmentApi[];
	total_price: MoneyApi;
}
